/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseConversation } from '../../models/api-response-conversation';

export interface ExistingConversationOfContact$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  contactPhone: string;
  companyPhone: string;
}

export function existingConversationOfContact(http: HttpClient, rootUrl: string, params: ExistingConversationOfContact$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseConversation>> {
  const rb = new RequestBuilder(rootUrl, existingConversationOfContact.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.query('contactPhone', params.contactPhone, {});
    rb.query('companyPhone', params.companyPhone, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseConversation>;
    })
  );
}

existingConversationOfContact.PATH = '/v1/api/ui/conversation/existing-conversation';
